import React from 'react';
import '../../styles/components/AsperaSearchHeader.scss';
import { Search, Switcher, SwitcherItem, Theme } from '../Carbon';
import { withRouter } from 'react-router-dom';
import { SubManager } from '../../classes/SubManager';
import { Subject } from 'rxjs';
import { AsperaError } from '../../classes/AsperaError';
import { AsperaWrapper } from '../AsperaWrapper';
import { language } from '../../services/LanguageService';
import { debounceTime } from 'rxjs/operators';
/**
 * React Component
 *
 * The AsperaSearchHeader component renders the search menu (right menu dropdown)
 *
 * @example
 * ```javascript
 * <AsperaSearchHeader />
 * ```
 */
export const AsperaSearchHeader = withRouter(class AsperaUserMenu extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false,
            error: false,
        };
        this.subManager = new SubManager();
        this.items = [];
        this.textSearchSub = new Subject();
        this.searchText = '';
        this.onChange = (text) => {
            const { onSearchCallback } = this.props;
            this.setState({ loading: true, error: false });
            if (!text) {
                this.items = [];
                this.setState({ loading: false });
                return;
            }
            this.subManager.setSubscription(onSearchCallback(text).subscribe({
                next: response => {
                    this.items = response;
                    this.setState({ loading: false });
                },
                error: error => {
                    new AsperaError('AsperaSearchHeader: Encountered an error searching', { error, text });
                    this.setState({ loading: false, error: true });
                },
            }));
        };
        this.searchDebounceChange = (event) => {
            var _a;
            this.searchText = ((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || '';
            this.textSearchSub.next(this.searchText);
        };
    }
    get errorProps() {
        return {
            title: language.get('header.unableToSearch'),
            body: language.get('header.unableToSearchBody'),
        };
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    componentDidUpdate(previousProps) {
        var _a;
        const { initialSearchResults, placeholder, className } = this.props;
        if (initialSearchResults && (initialSearchResults === null || initialSearchResults === void 0 ? void 0 : initialSearchResults.length) !== ((_a = previousProps.initialSearchResults) === null || _a === void 0 ? void 0 : _a.length)) {
            this.items = initialSearchResults;
            this.setState({});
        }
        if (placeholder !== previousProps.placeholder ||
            className !== previousProps.className) {
            this.setState({});
        }
    }
    componentDidMount() {
        const { initialSearchResults } = this.props;
        if (initialSearchResults === null || initialSearchResults === void 0 ? void 0 : initialSearchResults.length) {
            this.items = initialSearchResults;
            this.setState({});
        }
        this.subManager.setSubscription(this.textSearchSub.pipe(debounceTime(500)).subscribe({
            next: text => {
                this.onChange(text);
            },
            error: error => {
                new AsperaError('AsperaSearchHeader: Unable to subscribe to text search subscription', error);
            },
        }));
        const textField = document.querySelector('.aspera-search-menu--bar input');
        if (textField && typeof (textField === null || textField === void 0 ? void 0 : textField.focus) === 'function') {
            textField.focus();
        }
    }
    render() {
        const { className, onClick, placeholder, history } = this.props;
        const { error, loading } = this.state;
        return (React.createElement(Theme, { theme: "g100", className: `aspera-search-menu ${className ? className : ''}`, "data-auto": "search-menu-wrapper" },
            React.createElement("div", { className: "aspera-search-menu--bar-area" },
                React.createElement(Search, { className: "aspera-search-menu--bar", placeholder: placeholder || language.get('header.search'), onChange: this.searchDebounceChange, labelText: "" })),
            React.createElement(AsperaWrapper, { disableWrapping: true, error: error, loading: loading, errorProps: this.errorProps, smallRender: true },
                React.createElement(Switcher, { "aria-label": language.get('header.searchResults') }, this.items.length ? this.items.map((item, index) => {
                    return React.createElement(SwitcherItem, { key: index, "aria-label": item.name, onClick: () => {
                            if (item.onClick) {
                                item.onClick();
                            }
                            if (item.route) {
                                history.push(item.route);
                            }
                            if (onClick)
                                onClick();
                        }, "data-auto": `search-result-item-${item.name}` }, item.name);
                }) : !!this.searchText && React.createElement(SwitcherItem, { "aria-label": language.get('header.searchNoResults'), "data-auto": "serach-result-item-no-result" }, language.get('header.searchNoResults'))))));
    }
});
